module.exports = __webpack_public_path__ + "img/1.14.B.7cbc70e5.png";